export const USER_DATA_KEY = 'loggedUserData';
export const AUTH_FAIR_VALUE = 'authFairValue';
export const AUTH_PRICING = 'authPricing';
export const AUTH_SCOPERTURE = 'authScoperture';
export const LANG_KEY = 'language';
export const APP_VERSION_KEY = 'appVersion';
export const NAV_STATE_KEY = 'nav_state';
export const PAGE_TITLE = 'page_title';
export const IDS_SIM_SELECTED = 'ids_sim_selected';
export const PRICING_SELECTED = 'pricing';

export const LANGUAGES: any[] = [{ it: 'Italiano' }, { gb: 'English' }];

// costanti p-calendar:
export const CALENDAR_IT = {
  firstDayOfWeek: 1,
  dayNames: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
  dayNamesMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
  monthNames: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
  monthNamesShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
  today: 'Oggi',
  clear: 'Resetta'
};
export const CALENDAR_EN = {
  firstDayOfWeek: 1,
  dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  today: 'Today',
  clear: 'Clear'
};
export const GG_SETTIMANA = ['lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato', 'domenica'];

export const GG_SHORT_IT = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];
export const GG_SHORT_GB = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const X_TOTAL_COUNT = 'x-total-count'; // chiave header per record totali paginazione lato server
export const DATE_FORMAT_BE = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'; // formato json OK per backend
export const DATE_FORMAT_FE = 'DD/MM/YYYY hh:MM:ss'; // formato di visualizzazione date per frontend

export const DATE_FORMAT_JSON = 'yyyy-MM-ddTHH:mm:ssZ'; // formato json OK per backend
export const DATE_FORMAT_TABLE = 'dd/MM/yyyy'; // formato di visualizzazione date per frontend
export const DATETIME_FORMAT_TABLE = 'dd/MM/yyyy hh:mm'; // formato di visualizzazione date/tempo per frontend


// costanti patterns (x validazioni campi nei form):
export const PATTERN_CF = '^[a-zA-Z]{6}[0-9]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9]{2}([a-zA-Z]{1}[0-9]{3})[a-zA-Z]{1}$';
export const PATTERN_PI = '^[0-9]{11}';
export const PATTERN_CF_PI = '(^[a-zA-Z]{6}[0-9]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9]{2}([a-zA-Z]{1}[0-9]{3})[a-zA-Z]{1}$)|(^[0-9]{11})';
export const PATTERN_EMAIL = '^[A-Za-z0-9._%+-]+@[A-Za-z0-9._%+-]{2,}[.][A-Za-z]{2,}$';
export const PATTERN_TEL = '^(\\+)(\\d{1,3})?\\d{10}$';

export const PRIMARY_COLOR = '#3A4248';

// colors 
export const YELLOW_F300 = '#f2d066';
export const DARK_GREY = '#a9a9a9';
export const LIGHT_GREY = '#d1d3d4';
export const RED_INVALID = '#b30000';
export const YELLOW_WARNING = '#ffc107';
export const GREEN_VALID = '#008000';

export const FONTSIZE_TITOLO_TOOLTIP_GRAFICI = 16;

export const PRECISION_FACTOR_4 = 10000;